export default __webpack_public_path__ + "static/media/KZ.278a601b.png";